/* globals alert, console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

// @acavan! - this should really be filterSummariesList but not today...

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    BackboneRadio = require('backbone.radio'),
    _ = require('lodash'),
    //
    FiltersListItem = require('./filtersListItem'),
    configuration = require('../utilities/configuration'),
    enumerations = require('../utilities/enumerations').enumerations,
    formProcessor = require('../utilities/formProcessor').processor,
    templates = require('../utilities/handlebars').templates,
    helpers = require('../utilities/handlebars').helpers,
    user = require('../models/user'),
    EOL = null;

module.exports = Marionette.CollectionView.extend({
    attributes: {
        name: 'filtersList',
        class: 'filters-list'
    },
    channels: {
        analytics: BackboneRadio.channel('analytics')
    },
    childViewEvents: {
        'remove:filter': 'onRemoveFilter'
    },
    childView: FiltersListItem,
    childViewContainer: 'div[name=filtersListItems]',
    ui: {
        saveClearButtons: 'button'
    },
    tagName: 'div',
    template: templates.filtersList,
    initialize: function () {
        this.childViewOptions = this.options;
        if (this.options.popout) {
            this.emptyView = Marionette.View.extend({
                template: templates.filtersListEmpty
            });
        }
    },
    onRemoveFilter: function (group) {
        this.trigger('clear:group', group);
    },
    updateFilters: function (serializedFilters) {
        let processedFilters = formProcessor(serializedFilters, 'filters');
        return this.updateProcessedFilters(processedFilters);
    },
    updateProcessedFilters: function (processedFilters) {
        let id = 0,
            a = [];
        _.each(processedFilters, _.bind(function (values, key) {
            const descriptions = {
                    // @acavan! - these should come via l10n...
                    isFavorite: 'My favorites',
                    hasAdminAccess: 'Programs I manage',
                    sortby: 'Sort by',
                    vacancy: 'Vacancy: Has vacancies'
                };
            let description,
                tips,
                single;
            switch (key) {
                case 'favorites':
                    a.push({
                        id: id++,
                        group: 'favorites',
                        description: 'My favorites'
                    });
                    break;
                case 'keywords':
                    if (values) {
                        a.push({
                            id: id++,
                            group: 'keywords',
                            description: helpers.l10n('keywordsTitle', {}) + ': ' + values
                        });
                    }
                    break;
                case 'miles':
                    if (processedFilters.location) {
                        description = processedFilters.miles !== 12450.5 ? processedFilters.miles + ' miles from ' + processedFilters.location : 'Any distance from ' + processedFilters.location;
                        a.push({
                            id: id++,
                            group: 'distance',
                            description: description,
                            values: {
                                miles: processedFilters.miles,
                                latitude: processedFilters.latitude,
                                longitude: processedFilters.longitude,
                                location: processedFilters.location
                            }
                        });
                    } else {
                        this.trigger('location:cleared');
                    }
                    break;
                case 'isFavorite':
                case 'hasAdminAccess':
                case 'vacancy':
                    a.push({
                        id: id++,
                        group: key,
                        description: descriptions[key],
                        values: true
                    });
                    break;
                case 'invalidateCache':
                case 'latitude':
                case 'location':
                case 'longitude':
                case 'wantsOurServices':
                    // noops
                    break;
                case 'sortby':
                    if (values) {
                        a.push({
                            id: id++,
                            group: key,
                            description: descriptions[key] + ': ' + values,
                            values: values
                        });
                    }
                    break;
                default:
                    key = key.replace('Ids', '');
                    description = helpers.l10n(key + 'Title', {}) + ': ';
                    _.each(values, function (value, index) {
                        single = enumerations[key + 'Id'] ? true : false;
                        tips = enumerations[key + (single ? 'Id' : 'Ids')];
                        description += (index ? ', ' : '') + helpers.enumL10n({property: key + (single ? 'Id' : 'Ids'), id: value});
                    });
                    a.push({
                        id: id++,
                        group: key + (single ? 'Id' : 'Ids'),
                        description: description,
                        values: values
                    });
                    break;
            }
        }, this));
        this.collection.set(a);
        // send a Google Analytics event for every group mentioned in the filter set.
        _.each(a, _.bind(function (f) {
            this.channels.analytics.trigger('event', { category: 'places.filter', action: 'apply', label: f.group });
        }, this));
        return a.length;
    }
});
